module.exports = __webpack_public_path__ + "static/media/xiaoxiBuss.8e28ac33.svg";